export default __webpack_public_path__ + "static/media/sun.0e5cbd03.svg";